exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider[data-v-d4066e94]{width:200px}.colours-fan-page .details[data-v-d4066e94]{margin-bottom:0}", ""]);

// exports
